import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import map from 'lodash/map';
import * as actions from './TierOverride.ducks';

import themeable from 'zignal-landscape/lib/themeable';
// landscape components
import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';
import Grid from 'zignal-landscape/lib/Grid';
import GridContent from 'zignal-landscape/lib/GridContent';
import Row from 'zignal-landscape/lib/Row';
import Label from 'zignal-landscape/lib/Label';
import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';
import Button from 'zignal-landscape/lib/Button';
import Link from 'zignal-landscape/lib/Link';
import Field from 'zignal-landscape/lib/Field';
import Select from 'zignal-landscape/lib/Select';
import Loading from 'zignal-landscape/lib/Loading';
import Banner from 'zignal-landscape/lib/Banner';

import SettingsPageHeader from 'components/SettingsPageHeader';

export const mapStateToProps = (
  (state) => ({
    loading: state.TierOverride.loading,
    tiers: state.TierOverride.tiers,
    errors: state.TierOverride.errors,
    isConfirmModalOpen: state.TierOverride.isConfirmModalOpen,
    isUnsaved: state.TierOverride.isUnsaved,
    saveSucceeded: state.TierOverride.saveSucceeded,
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class TierOverride extends Component {

  constructor(props){
    super(props);
    this.checkForChanges = this.checkForChanges.bind(this);
    this.handleClickEvent = this.handleClickEvent.bind(this);
    this.closeSuccessAlert = this.closeSuccessAlert.bind(this);
  }

  componentDidMount(){
    const { accountId, loadProps, fetchDomains } = this.props;
    loadProps({accountId});
    fetchDomains();
    this.handleClickEvent('on');
  }

  componentWillUnmount(){
    this.handleClickEvent('off');
  }

  handleClickEvent(toggle){
    window.$('#settings-tabs .menu-item')
      .not('.account_tier-override')[toggle]('click', this.checkForChanges);
  }

  checkForChanges(e){
    const { isUnsaved, openConfirmModal } = this.props;
    // only stop redirect if there are unsaved changes
    if (isUnsaved){
      e.stopImmediatePropagation();
      // 'redirectTarget' will let saga know to redirect user after confirm
      openConfirmModal({redirectTarget: e.currentTarget});
    }
  }

  closeSuccessAlert() {
    this.props.resetSuccessMessage();
  }

  render() {
    const {
      styles,
      loading,
      tiers,
      // errors,
      isConfirmModalOpen,
      isUnsaved,
      // actions
      openConfirmModal,
      hideConfirmModal,
      confirmCancel,
      handleDomainChange,
      updateDomains,
      saveSucceeded,
    } = this.props;

    const headingText = 'Tier Override';
    const italicText = 'Re-assign domains according to your perceived value.' +
      ' Tier 1 are the most valuable domains.';
    const confirmModalTitle = 'Cancel';
    const confirmModalText = 'You will lose any unsaved changes. Are you sure you want to continue?';
    const inputs = [1,2,3];
    const successBannerTitle = 'Your Overrides Have Been Saved';
    const successBannerMessage = 'We will notify you once all story scores have been updated.';

    return (
      <div>
        <GridContent>
          {loading ? (
            <div className={styles.loadingContainer}><Loading /></div>
          ) : (
            <Grid fluid>
              {saveSucceeded && (
                <Row className={styles.notificationWrapper}>
                  <Banner
                    bannerStyle="inline"
                    bannerType="success"
                    title={successBannerTitle}
                    onClick={this.closeSuccessAlert}
                  >
                    {successBannerMessage}
                  </Banner>
                </Row>
              )}
              <Row>
                <SettingsPageHeader headingText={headingText} italicText={italicText} />
              </Row>
              <Row>
                {
                  inputs.map((num) => {
                    const key = `tier${num}`;
                    const tierDomains = tiers[key];
                    // TEMP - hide errors for now, product decision
                    // const error = errors[key];
                    return (
                      <Field key={key}>
                        <Label htmlFor={key} inline >{`Tier ${num}`}</Label>
                        <Select
                          isMulti
                          allowCreate
                          value={tierDomains.map((value) => ({value, label: value}))}
                          placeholder={''}
                          onChange={(options) => {
                            const domains = map(options, 'value');
                            handleDomainChange({ domains, key });
                          }}
                        // errorMessage={error}
                        />
                      </Field>
                    );
                  })
                }
              </Row>
              <Row>
                <ButtonGroup align="right">
                  <Link
                    disabled={!isUnsaved}
                    linkType="cancel"
                    onClick={isUnsaved ? openConfirmModal : noop}
                  >
                    Cancel
                  </Link>
                  <Button
                    disabled={!isUnsaved}
                    buttonStyle="positive"
                    onClick={isUnsaved ? updateDomains : noop}
                  >
                    Save
                  </Button>
                </ButtonGroup>
              </Row>
            </Grid>
          )}
        </GridContent>
        <ConfirmationModal
          isOpen={isConfirmModalOpen}
          confirmStyle="delete"
          confirmText="Continue"
          title={confirmModalTitle}
          onCancel={hideConfirmModal}
          onConfirm={confirmCancel}
        >
          {confirmModalText}
        </ConfirmationModal>
      </div>
    );
  }

}

TierOverride.propTypes = {
  styles: PropTypes.object,
  tiers: PropTypes.object,
  errors: PropTypes.object,
  loading: PropTypes.bool,
  isConfirmModalOpen: PropTypes.bool,
  isUnsaved: PropTypes.bool,
  saveSucceeded: PropTypes.bool,
  accountId: PropTypes.string,
  // actions
  openConfirmModal: PropTypes.func,
  hideConfirmModal: PropTypes.func,
  confirmCancel: PropTypes.func,
  handleDomainChange: PropTypes.func,
  updateDomains: PropTypes.func,
  loadProps: PropTypes.func,
  fetchDomains: PropTypes.func,
  resetSuccessMessage: PropTypes.func,
};

TierOverride.defaultProps = {
  styles: {},
  tiers: { tier1: [], tier2: [], tier3: [] },
  errors: {}
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(TierOverride));
